import { LegalLayout } from "./LegalLayout";
import { EMAIL, WHATSAPP_DISPLAY, ADDRESS } from "../../data/site";

export const Pending = ({ children }) => (
  <span className="rounded-md bg-amber-50 px-1.5 py-0.5 font-medium text-amber-700 ring-1 ring-amber-200">
    {children} <em className="not-italic text-amber-500">[a confirmar pelo proprietário]</em>
  </span>
);

const H2 = ({ children }) => (
  <h2 className="mt-8 text-xl font-bold tracking-tight text-navy">{children}</h2>
);
const P = ({ children }) => <p className="mt-3 text-sm leading-relaxed text-slate-600">{children}</p>;
const UL = ({ children }) => (
  <ul className="mt-3 list-disc space-y-1.5 pl-5 text-sm leading-relaxed text-slate-600">{children}</ul>
);

export const LegalSection = { H2, P, UL };

export const CONTACT_BLOCK = (
  <>
    <H2>Contactos</H2>
    <P>
      Para qualquer questão relacionada com esta página, pode contactar a TopEstofos através de:
    </P>
    <UL>
      <li>E-mail: {EMAIL}</li>
      <li>Telefone / WhatsApp: {WHATSAPP_DISPLAY}</li>
      <li>Morada: {ADDRESS}</li>
    </UL>
  </>
);
